// primeng components
import { InputTextModule } from 'primeng/inputtext';
import { CardModule } from 'primeng/card';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ButtonModule } from 'primeng/button';

// Reactive form for generate and validate the form
import { ReactiveFormsModule } from '@angular/forms';

import { AlertModule } from './alert/alert.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { CoreModule } from './core/core.module';
import { FormsModule } from '@angular/forms';
import { LmsBaseAppComponent } from './core/component/base-app/lms-base-app.component';
import { LocoModule } from './loco/loco.module';
import { LocoStatusModule } from './loco-status/loco-status.module';
import { NgModule } from '@angular/core';
import { QueryViewModule } from './query-view/query-view.module';
import { SharedModule } from './shared/shared.module';
import { TerminalModule } from './terminal/terminal.module';
import { TrainModule } from './train/train.module';
import { TonnageRatingsModule } from './tonnage-ratings/tonnage-ratings.module';
import { YardLocalModule } from './yard-local/yard-local.module';
import { OutlyingPointModule } from './outlying-point/outlying-point.module';
import { HttpClientModule } from '@angular/common/http';
import { CsxSecurityModule, SecurityConfigInjectionToken } from '@csx/security';
import { SecConfig } from './security/security.config';
import { NotAuthorizedComponent } from './not-authorized/not-authorized.component';
import { HelpDocsModule } from './help-docs/help-docs.module';
/**
 * @export
 * @class AppModule
 */
@NgModule({
  declarations: [
    AppComponent,
    LmsBaseAppComponent,
    NotAuthorizedComponent  
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    InputTextModule,
    RadioButtonModule,
    ButtonModule,
    CoreModule,
    LocoModule,
    AlertModule,
    LocoStatusModule,
    TrainModule,
    TonnageRatingsModule,
    SharedModule,
    TerminalModule,
    QueryViewModule,
    AppRoutingModule,
    YardLocalModule,
    OutlyingPointModule,
    CardModule,
    ReactiveFormsModule,
    CsxSecurityModule.initialize(),    
    HelpDocsModule
  ],
  exports: [AppRoutingModule],
  providers: [
    { provide: SecurityConfigInjectionToken, useValue: SecConfig }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
